import ImagesPressFoundersJanisFounderJanis2Jpg from '@/public/images/press/founders/janis/founder_janis2.jpg';
import ImagesPressFoundersJanisFounderJanisJpg from '@/public/images/press/founders/janis/founder_janis.jpg';
import ImagesPressFoundersJanisJanisWilzcuraJpeg from '@/public/images/press/founders/janis/Janis_Wilzcura.jpeg';

export {
  ImagesPressFoundersJanisFounderJanis2Jpg,
  ImagesPressFoundersJanisFounderJanisJpg,
  ImagesPressFoundersJanisJanisWilzcuraJpeg,
};
